const en = {
  // Navbar
  "nav.home": "Home",
  "nav.products": "Products",
  "nav.categories": "Categories",
  "nav.deals": "Deals",
  "nav.cart": "Cart",
  "nav.wishlist": "Wishlist",
  "nav.account": "Account",
  "nav.login": "Sign In",
  "nav.register": "Sign Up",
  "nav.logout": "Log Out",
  "nav.search_placeholder": "Search products...",
  "nav.admin": "Admin",

  // Hero
  "hero.trusted_by": "Trusted by 50,000+ happy customers",
  "hero.title_line1": "Discover Quality",
  "hero.title_line2": "For Everyday Life",
  "hero.subtitle": "From home essentials to the latest gadgets, we bring you carefully curated products at prices you'll love. Free shipping on orders over $50.",
  "hero.shop_now": "Shop Now",
  "hero.explore": "Explore Deals",

  // Categories
  "categories.label": "Browse Categories",
  "categories.title": "Everything You Need",
  "categories.subtitle": "Explore our wide range of categories, each filled with handpicked products just for you.",

  // Featured Products
  "featured.label": "Featured Products",
  "featured.title": "Our Top Picks",
  "featured.subtitle": "Handpicked favorites our customers keep coming back for.",
  "featured.view_all": "View All Products",
  "featured.add_to_cart": "Add to Cart",
  "featured.sale": "Sale",
  "featured.new": "New",

  // Testimonials
  "testimonials.title": "( What Our Customers Say )",
  "testimonials.rating": "Rated 4.9 out of 5",
  "testimonials.review_1": "I've been shopping here for over a year now and the quality never disappoints. Fast shipping and great customer service make all the difference.",
  "testimonials.name_1": "Sarah Mitchell",
  "testimonials.role_1": "Verified Buyer",
  "testimonials.review_2": "The product variety is incredible. I always find exactly what I need, and the prices are unbeatable compared to other stores.",
  "testimonials.name_2": "James Rodriguez",
  "testimonials.role_2": "Loyal Customer",

  // CTA
  "cta.title": "Ready To Upgrade Your Lifestyle?",
  "cta.subtitle_line1": "Join thousands of happy shoppers and discover",
  "cta.subtitle_line2": "products that make everyday life better.",
  "cta.button": "Start Shopping",

  // Newsletter
  "newsletter.title": "Stay in the Loop",
  "newsletter.subtitle": "Subscribe to get exclusive deals, new arrivals, and insider tips delivered straight to your inbox.",
  "newsletter.placeholder": "Enter your email address",
  "newsletter.button": "Subscribe",
  "newsletter.success": "Thanks for subscribing! Check your inbox for a welcome gift.",
  "newsletter.privacy": "No spam, ever. We respect your privacy.",

  // Footer
  "footer.brand": "Galore",
  "footer.description": "Your one-stop shop for quality products across every category. We believe shopping should be simple, enjoyable, and rewarding.",
  "footer.address_title": "Address",
  "footer.address_line1": "123 Commerce Street",
  "footer.address_line2": "New York, NY 10001",
  "footer.phone_title": "Phone",
  "footer.phone": "+1 (555) 234-5678",
  "footer.email_title": "Email",
  "footer.email": "hello@generalstore.com",
  "footer.shop": "Shop",
  "footer.company": "Company",
  "footer.support": "Support",
  "footer.all_products": "All Products",
  "footer.new_arrivals": "New Arrivals",
  "footer.best_sellers": "Best Sellers",
  "footer.deals_footer": "Deals & Offers",
  "footer.about_us": "About Us",
  "footer.careers": "Careers",
  "footer.contact": "Contact",
  "footer.blog": "Blog",
  "footer.help_center": "Help Center",
  "footer.shipping": "Shipping Info",
  "footer.returns": "Returns & Refunds",
  "footer.faq": "FAQ",
  "footer.copyright": "© 2026 Galore. All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",
  "footer.cookies": "Cookie Policy",

  // Cart
  "cart.empty": "Your cart is empty",
  "cart.title": "Shopping Cart",
  "cart.quantity": "Qty",
  "cart.subtotal": "Subtotal",
  "cart.checkout": "Proceed to Checkout",
  "cart.continue_shopping": "Continue Shopping",
  "cart.remove": "Remove",
  "cart.empty_message": "Looks like you haven't added anything to your cart yet. Start exploring our products and find something you love!",
  "cart.start_shopping": "Start Shopping",
  "cart.summary": "Order Summary",
  "cart.shipping": "Shipping",
  "cart.free_shipping": "Free",
  "cart.total": "Total",
  "cart.item_count": "{{count}} item",
  "cart.item_count_plural": "{{count}} items",
  "cart.coupon_placeholder": "Enter coupon code",
  "cart.apply": "Apply",
  "cart.added_toast": "Added to cart",
  "cart.save_for_later": "Save for Later",
  "cart.move_to_cart": "Move to Cart",
  "cart.saved_title": "Saved for Later",
  "cart.saved_count": "{{count}} saved item",
  "cart.saved_count_plural": "{{count}} saved items",
  "cart.saved_empty": "No saved items",
  "cart.clear_saved": "Clear Saved",

  // Product
  "product.out_of_stock": "Out of Stock",
  "product.in_stock": "In Stock",
  "product.add_to_cart": "Add to Cart",
  "product.add_to_wishlist": "Add to Wishlist",
  "product.description": "Description",
  "product.reviews": "Reviews",
  "product.related": "Related Products",
  "product.recently_viewed": "Recently Viewed",

  // Auth - Phone
  "auth.welcome_back": "Welcome Back",
  "auth.login_subtitle": "Enter your phone number to sign in",
  "auth.phone_number": "Phone Number",
  "auth.send_code": "Send Code",
  "auth.enter_code": "Enter Verification Code",
  "auth.code_sent": "Code sent!",
  "auth.resend_code": "Resend Code",
  "auth.resend_in": "Resend in",
  "auth.didnt_receive": "Didn't receive the code?",
  "auth.wrong_number": "Wrong number?",
  "auth.change_number": "Change number",
  "auth.verifying": "Verifying...",
  "auth.verified": "Verified!",
  "auth.redirecting": "Redirecting...",
  "auth.create_account_title": "Create Account",
  "auth.create_account_subtitle": "Enter your details to get started",
  "auth.no_account_phone": "Don't have an account?",
  "auth.has_account_phone": "Already have an account?",
  "auth.sign_up": "Sign Up",
  "auth.sign_in": "Sign In",
  "auth.full_name": "Full Name",
  "auth.sign_in_to_continue": "Sign In to Continue",
  "auth.please_sign_in": "You need to be signed in to access this page. Please sign in or create an account to continue.",
  "auth.go_to_sign_in": "Go to Sign In",

  // Auth - Email fallback
  "auth.email": "Email Address",
  "auth.password": "Password",
  "auth.forgot_password": "Forgot Password?",
  "auth.no_account": "Don't have an account?",
  "auth.has_account": "Already have an account?",
  "auth.confirm_password": "Confirm Password",

  // Checkout
  "checkout.title": "Checkout",
  "checkout.breadcrumb": "Checkout",
  "checkout.shipping_info": "Shipping Information",
  "checkout.full_name": "Full Name",
  "checkout.email": "Email Address",
  "checkout.phone": "Phone Number",
  "checkout.address_line1": "Address Line 1",
  "checkout.address_line2": "Address Line 2 (Optional)",
  "checkout.city": "City",
  "checkout.state": "State / Province",
  "checkout.zip": "ZIP / Postal Code",
  "checkout.country": "Country",
  "checkout.select_country": "Select Country",
  "checkout.order_summary": "Order Summary",
  "checkout.items_count": "{{count}} item",
  "checkout.items_count_plural": "{{count}} items",
  "checkout.subtotal": "Subtotal",
  "checkout.shipping": "Shipping",
  "checkout.free": "Free",
  "checkout.tax": "Tax (estimated)",
  "checkout.total": "Total",
  "checkout.pay_now": "Pay Now",
  "checkout.processing": "Processing payment...",
  "checkout.secure_checkout": "Secure Checkout",
  "checkout.ssl_encrypted": "Your data is protected with 256-bit SSL encryption",
  "checkout.back_to_cart": "Back to Cart",
  "checkout.empty_cart": "Your cart is empty. Add some products before checking out.",
  "checkout.field_required": "This field is required",
  "checkout.invalid_email": "Please enter a valid email address",
  "checkout.guest_title": "Guest Checkout",
  "checkout.guest_message": "You're checking out as a guest — no account needed. Just fill in your details below and you're all set.",
  "checkout.guest_perk": "Want order tracking and faster checkout next time?",
  "checkout.create_account": "Create an account",

  // Checkout Success
  "success.title": "Order Confirmed!",
  "success.subtitle": "Thank you for your purchase. Your order has been placed successfully.",
  "success.order_number": "Order Number",
  "success.order_date": "Order Date",
  "success.estimated_delivery": "Estimated Delivery",
  "success.shipping_to": "Shipping To",
  "success.payment_method": "Payment Method",
  "success.payment_visa": "Visa ending in 4242",
  "success.confirmation_email": "A confirmation email has been sent to your email address.",
  "success.continue_shopping": "Continue Shopping",
  "success.view_order": "View Order",
  "success.whats_next": "What's Next?",
  "success.track_info": "You'll receive tracking information via email once your order ships.",
  "success.questions": "Have any questions? Contact our support team.",
  "success.contact_support": "Contact Support",

  // Account
  "account.my_account": "My Account",
  "account.orders": "My Orders",
  "account.wishlist": "Wishlist",
  "account.settings": "Settings",
  "account.order_history": "Order History",
  "account.dashboard": "Dashboard",
  "account.welcome_back": "Welcome back",
  "account.total_orders": "Total Orders",
  "account.total_spent": "Total Spent",
  "account.wishlist_count": "Wishlist",
  "account.recent_orders": "Recent Orders",
  "account.view_all_orders": "View All Orders",
  "account.no_orders": "No orders yet",
  "account.no_orders_desc": "You have not placed any orders yet. Start shopping and your orders will appear here.",
  "account.start_shopping": "Start Shopping",
  "account.order_number": "Order",
  "account.order_date": "Date",
  "account.order_status": "Status",
  "account.order_total": "Total",
  "account.order_details": "Order Details",
  "account.back_to_orders": "Back to Orders",
  "account.order_summary": "Order Summary",
  "account.shipping_address": "Shipping Address",
  "account.payment_method": "Payment Method",
  "account.tracking_number": "Tracking Number",
  "account.estimated_delivery": "Estimated Delivery",
  "account.subtotal": "Subtotal",
  "account.shipping": "Shipping",
  "account.tax": "Tax",
  "account.item": "item",
  "account.items": "items",
  "account.order_placed": "Order placed",
  "account.track_order": "Track Order",
  "account.buy_again": "Buy Again",
  "account.reorder": "Reorder Items",
  "account.reorder_success": "All items added to cart!",
  "account.reorder_partial": "{{count}} item added to cart ({{skipped}} unavailable)",
  "account.empty_wishlist": "Your wishlist is empty",
  "account.empty_wishlist_desc": "Save your favorite products by clicking the heart icon on any product. They will appear here.",
  "account.browse_products": "Browse Products",
  "account.remove_from_wishlist": "Remove",
  "account.added": "Added",
  "account.settings_title": "Account Settings",
  "account.settings_subtitle": "Manage your personal information and preferences",
  "account.profile_info": "Profile Information",
  "account.preferences": "Preferences",
  "account.full_name_label": "Full Name",
  "account.phone_label": "Phone Number",
  "account.email_label": "Email Address",
  "account.email_placeholder": "your@email.com",
  "account.save_changes": "Save Changes",
  "account.saved": "Changes saved successfully!",
  "account.language_pref": "Language Preference",
  "account.currency": "Currency",
  "account.email_notifications": "Email Notifications",
  "account.order_updates": "Order updates",
  "account.promotions": "Promotions and deals",
  "account.newsletter": "Weekly newsletter",
  "account.danger_zone": "Danger Zone",
  "account.delete_account": "Delete Account",
  "account.delete_warning": "Once you delete your account, there is no going back. Please be certain.",
  "account.delete_button": "Delete My Account",

  // Products - Filters
  "products.filters": "Filters",
  "products.filters_count": "{{count}} filter",
  "products.filters_count_plural": "{{count}} filters",
  "products.show_results": "Show {{count}} Results",
  "products.sort_by": "Sort by",
  "products.sort_newest": "Newest",
  "products.sort_price_low": "Price: Low to High",
  "products.sort_price_high": "Price: High to Low",
  "products.sort_rating": "Highest Rated",
  "products.search_label": "Search",
  "products.category_label": "Categories",
  "products.price_label": "Price Range",
  "products.rating_label": "Minimum Rating",
  "products.rating_and_up": "&amp; up",
  "products.in_stock_only": "In Stock Only",
  "products.clear_all": "Clear All Filters",
  "products.no_products": "No products found",
  "products.no_products_desc": "Try adjusting your filters or search terms",
  "products.results_count": "{{count}} product found",
  "products.results_count_plural": "{{count}} products found",
  "products.tag_price": "${{min}} — ${{max}}",
  "products.quick_view": "Quick View",
  "products.view_full_details": "View full details",
  "products.close": "Close",
  "products.load_more": "Load More Products",
  "products.showing_count": "Showing {{shown}} of {{total}} products",

  // Admin
  "admin.dashboard": "Dashboard",
  "admin.products": "Products",
  "admin.orders": "Orders",
  "admin.customers": "Customers",
  "admin.analytics": "Analytics",
  "admin.add_product": "Add Product",
  "admin.edit_product": "Edit Product",
  "admin.delete_product": "Delete Product",
  "admin.update_status": "Update Status",
  "admin.total_revenue": "Total Revenue",
  "admin.recent_orders": "Recent Orders",
  "admin.view_all": "View All",
  "admin.search_placeholder": "Search...",
  "admin.all_categories": "All Categories",
  "admin.all_status": "All Status",
  "admin.in_stock": "In Stock",
  "admin.out_of_stock": "Out of Stock",
  "admin.save_changes": "Save Changes",
  "admin.cancel": "Cancel",
  "admin.confirm_delete": "Delete Product",
  "admin.confirm_delete_message": "Are you sure you want to delete",
  "admin.no_products": "No products match your filters",
  "admin.no_orders": "No orders found",
  "admin.no_customers": "No customers match your search",
  "admin.customer_since": "Customer since",

  // General
  "general.loading": "Loading...",
  "general.error": "Something went wrong",
  "general.retry": "Try Again",
  "general.view_all": "View All",
  "general.no_results": "No results found",
  "general.scroll_to_top": "Scroll to top",

  // Language
  "language.en": "English",
  "language.ar": "العربية",
};

export default en;